(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-event-2023-sec-page"]) return;
  try {
    
  $(".black-friday-event-2023 .bk-faq .item h3").click(function () {
    $(this).next("div.text").slideToggle();
    $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["christmas-party-dreses"]) return;
  try {
    
  $(".loadmore").click(function(){
    $(this).hasClass("active") ? $(this).text("Load More").removeClass("active") : $(this).text("See Less >").addClass("active");
    $(this).parent("div.text").toggleClass("active");
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faqs"] && !window.DesignMode) return;
  try {
    
  $(".custom-faqs-section .item h3").click(function(){
    $(this).toggleClass("active");
    $(this).next("div.text").slideToggle();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cyber-monday"]) return;
  try {
    
  $(".cyber-faq .item h3").click(function () {
    $(this).next("div.text").slideToggle();
    $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-black-friday-event-2023-page"]) return;
  try {
    
  $(".black-friday-event-2023 .bk-faq .item h3").click(function () {
    $(this).next("div.text").slideToggle();
    $(this).hasClass("active") ? $(this).removeClass("active") : $(this).addClass("active");
  });



  



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-holiday-dresses"]) return;
  try {
    
  $(".loadmore").click(function(){
    $(this).hasClass("active") ? $(this).text("Load More").removeClass("active") : $(this).text("See Less >").addClass("active");
    $(this).parent("div.text").toggleClass("active");
  })

  } catch(e) { console.error(e); }
})();
})();
